export default class ProductSearchRepository {
    constructor() {
        this.htmlByTerm = new Map();
        this.request = null;
    }

    /**
     * @param {string} term
     * @returns {Promise<string>}
     */
    getHtml(term) {
        this.abort();
        if (this.htmlByTerm.has(term)) {
            return Promise.resolve(this.htmlByTerm.get(term));
        }

        this.request = jQuery.ajax({
            url: orchid_store_kc_product_search.url,
            data: {term: term},
            dataType: 'json'
        });

        return Promise.resolve(this.request).then((response) => {
            this.htmlByTerm.set(term, response.data.html);
            return response.data.html;
        });
    }

    abort() {
        if (this.request) {
            this.request.abort();
            this.request = null;
        }
    }
}
